import posthog from "posthog-js";
import { TRACKING_ENABLED } from "@/shared/analytics/tracking";
import { isBackendPath } from "@/shared/lib/backend-paths";

if (TRACKING_ENABLED && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  // Backend surfaces (admin, partner, customer token pages) stay out of
  // product analytics, but a crash there is the one we most need to see — so
  // they initialise with exception capture only.
  const analytics = !isBackendPath(window.location.pathname);

  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    // Ingestion runs through our own domain, so posthog-js cannot infer which
    // cloud region hosts the UI and would link to us.posthog.com. Only affects
    // links out of the SDK (toolbar, recording URLs) — not where events go.
    ui_host: "https://eu.posthog.com",
    defaults: "2026-01-30",
    capture_pageview: false,
    capture_exceptions: true,
    disable_session_recording: true,
    ...(analytics
      ? {}
      : {
          autocapture: false,
          capture_pageleave: false,
          capture_heatmaps: false,
          disable_surveys: true,
        }),
  });

  // The recorder (~113 KiB) waits for `load` so it never competes with the LCP;
  // it snapshots the DOM when it starts, so the recording is complete from there.
  if (analytics) {
    const startRecording = () => posthog.startSessionRecording();
    if (document.readyState === "complete") startRecording();
    else window.addEventListener("load", startRecording, { once: true });
  }
}
